import domReady from '@wordpress/dom-ready';

function injectMainToggleButton() {
	const container = document.querySelector( '.site-header .wrap' );
	const navigation = container.querySelector( '.wp-block-navigation' );
	const btn = document.createElement( 'button' );
	btn.className =
		'wp-block-data-revolt-blocks-mobile-menu-toggle menu-toggle';
	btn.setAttribute( 'aria-label', 'Toggle Main Menu' );
	btn.setAttribute( 'aria-expanded', 'false' );
	btn.innerHTML = `<span></span>`;
	container.appendChild( btn );
	animateMenuEntryExit( btn, navigation );
}

function removeActiveBtnState( menus ) {
	menus.forEach( ( menu ) => {
		menu.classList.remove( 'is-open' );
		const toggleBtn = menu.querySelector(
			'.wp-block-data-revolt-blocks-menu-box-toggle'
		);
		if ( toggleBtn ) {
			toggleBtn.setAttribute( 'aria-expanded', 'false' );
		}
	} );
}

function animateMenuEntryExit( btn, navigation ) {
	let isOpen = false;

	btn.addEventListener( 'click', () => {
		if ( ! isOpen ) {
			// Opening from left
			navigation.classList.remove( 'open-right' );
			navigation.style.transform = 'translateX(0)'; // ensure start pos
			navigation.style.visibility = 'visible'; // show
			btn.setAttribute( 'aria-expanded', 'true' );
			// eslint-disable-next-line no-undef
			requestAnimationFrame( () => {
				navigation.classList.add( 'open-left' );
			} );
			isOpen = true;
		} else {
			// Closing to right
			navigation.classList.remove( 'open-left' );
			navigation.classList.add( 'open-right' );
			navigation.style.transform = 'translateX(100%)';
			btn.setAttribute( 'aria-expanded', 'false' );
			isOpen = false;

			// After closing to right, instantly put it back off-screen left (no flash)
			navigation.addEventListener(
				'transitionend',
				function resetPosition( e ) {
					// console.log( 'Transition ended:', e.propertyName );
					if ( e.propertyName === 'transform' && ! isOpen ) {
						btn.setAttribute( 'aria-expanded', 'false' );
						btn.disabled = true;
						navigation.style.visibility = 'hidden'; // hide instantly after animation
						setTimeout( () => {
							navigation.style.transform = 'translateX(-100%)'; // reset off-screen left
							navigation.classList.remove( 'open-right' );
							btn.disabled = false; // re-enable button
						}, 500 );
					}
					navigation.removeEventListener(
						'transitionend',
						resetPosition
					);
				}
			);
		}
	} );
}

function runMobileMenu() {
	const menuBoxes = document.querySelectorAll(
		'.wp-block-data-revolt-blocks-menu-box-wrapper'
	);
	menuBoxes.forEach( ( box ) => {
		const menu = box.querySelector( '.wp-block-navigation' );
		if ( ! menu ) return;
		const toggleBtn = document.createElement( 'button' );
		toggleBtn.className = 'wp-block-data-revolt-blocks-menu-box-toggle';
		toggleBtn.setAttribute( 'aria-label', 'Toggle Menu' );
		toggleBtn.setAttribute( 'aria-expanded', 'false' );
		toggleBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false" fill="none"><path d="M1.50002 4L6.00002 8L10.5 4" stroke-width="1.5"></path></svg>`;
		box.appendChild( toggleBtn );

		box.addEventListener( 'click', () => {
			if ( box.classList.contains( 'is-open' ) ) {
				removeActiveBtnState( menuBoxes );
				return;
			}
			removeActiveBtnState( menuBoxes );
			box.classList.toggle( 'is-open' );
			// toggleBtn.classList.toggle( 'is-open' );
			toggleBtn.setAttribute(
				'aria-expanded',
				box.classList.contains( 'is-open' )
			);
		} );
	} );
}

function deactivateMobileElements() {
	const btn = document.querySelector(
		'.wp-block-data-revolt-blocks-mobile-menu-toggle'
	);
	const mainNav = document.querySelector(
		'.site-header .wp-block-navigation'
	);
	if ( btn ) {
		btn.style.display = 'none';
	}
	if ( ! mainNav ) return;
	// console.log( 'Deactivating mobile elements' );
	mainNav.style.visibility = 'visible';
	mainNav.style.transform = 'none';
	mainNav.classList.remove( 'open-left', 'open-right' );
}

function activateMobileElements() {
	// console.log( 'Activating mobile elements' );
	const btn = document.querySelector(
		'.wp-block-data-revolt-blocks-mobile-menu-toggle'
	);
	const mainNav = document.querySelector(
		'.site-header .wp-block-navigation'
	);
	if ( btn ) {
		btn.style.display = 'block';
	}
	if ( mainNav ) {
		mainNav.style.visibility = 'hidden';
		mainNav.style.transform = 'translateX(-100%)';
		mainNav.classList.remove( 'open-left', 'open-right' );
	}
}

domReady( () => {
	const mobileMedia = window.matchMedia( '(max-width: 1023px)' );
	// console.log( 'Mobile media query matches:', mobileMedia );
	if ( mobileMedia.matches ) {
		// console.log( 'this is running?' );
		injectMainToggleButton();
		runMobileMenu();
	}
	mobileMedia.addEventListener( 'change', ( e ) => {
		// 	console.log( 'Media query changed:', e.matches );
		if ( ! e.matches ) {
			deactivateMobileElements();
			// console.log( 'Media query changed deactivate element:' );
			return false;
		}
		// console.log( 'Media query changed activate element:' );
		//btn show
		//nav inline style transform - 100% visibility hidden
		injectMainToggleButton();
		runMobileMenu();
		activateMobileElements();
	} );
} );
